import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarningSquareLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.835 4.91988C4.15879 5.64599 3.75 6.70868 3.75 8.02638V15.9736C3.75 17.2913 4.15879 18.354 4.83492 19.0802C5.50543 19.8002 6.49437 20.25 7.78313 20.25H16.2178C17.5017 20.25 18.4908 19.8006 19.1625 19.0799C19.8398 18.3533 20.25 17.2905 20.25 15.9736V8.02638C20.25 6.70858 19.8414 5.64586 19.1655 4.91976C18.4952 4.19974 17.5065 3.75 16.2178 3.75H7.78411C6.49479 3.75 5.5056 4.1998 4.835 4.91988ZM3.7373 3.89761C4.72148 2.8408 6.12435 2.25 7.78411 2.25H16.2178C17.8772 2.25 19.2796 2.84086 20.2634 3.89772C21.2416 4.94852 21.75 6.39899 21.75 8.02638V15.9736C21.75 17.6019 21.2388 19.0523 20.2598 20.1026C19.2753 21.1588 17.8733 21.75 16.2178 21.75H7.78313C6.12379 21.75 4.72117 21.1592 3.73714 20.1023C2.75873 19.0516 2.25 17.6011 2.25 15.9736V8.02638C2.25 6.39889 2.75873 4.94839 3.7373 3.89761Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.0059 7.35742C12.4201 7.35742 12.7559 7.69321 12.7559 8.10742V11.9993C12.7559 12.4135 12.4201 12.7493 12.0059 12.7493C11.5917 12.7493 11.2559 12.4135 11.2559 11.9993V8.10742C11.2559 7.69321 11.5917 7.35742 12.0059 7.35742ZM12.0059 14.9426C12.4201 14.9426 12.7559 15.2784 12.7559 15.6926V15.7407C12.7559 16.1549 12.4201 16.4907 12.0059 16.4907C11.5917 16.4907 11.2559 16.1549 11.2559 15.7407V15.6926C11.2559 15.2784 11.5917 14.9426 12.0059 14.9426Z",
		fill: "currentColor"
	})]
});
export default SvgWarningSquareLine;
